import React from 'react';
import $ from 'jquery';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ThemeSetup } from '../themes/ThemeSetup';

export default class ReactSelect extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    directionUp: PropTypes.bool,
    options: PropTypes.array,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    dropDownClearable: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    value: PropTypes.any
  };

  static defaultProps = {
    dropDownClearable: false,
    directionUp: false,
    onOpen: $.noop,
    onClose: $.noop
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value ? props.value : null
    };

    this.setValue = this.setValue.bind(this);
    this.arrowRenderer = this.arrowRenderer.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }
  }

  setValue(value) {
    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  arrowRenderer() {
    const { directionUp } = this.props;
    if (directionUp) {
      return <i style={style.arrowStyleUp} />;
    }
    return <i style={style.arrowStyle} />;
  }

  render() {
    const { placeholder, options, disabled, directionUp } = this.props;
    const { value } = this.state;

    let classContainer = null;
    if (directionUp) {
      classContainer = 'direction-up';
    }

    return (
      <Select
        required
        arrowRenderer={this.arrowRenderer}
        name=""
        onInputChange={(inputValue) => (this._inputValue = inputValue)}
        placeholder={placeholder}
        value={value}
        options={options}
        clearable={this.props.dropDownClearable}
        onChange={this.setValue}
        disabled={disabled}
        onOpen={this.props.onOpen}
        onClose={this.props.onClose}
        className={classContainer}
      />
    );
  }
}

const style = {
  arrowStyle: {
    backgroundImage: 'url(images/arrow_down.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    display: 'inline-block',
    height: '14px',
    width: '10px'
  },
  arrowStyleUp: {
    backgroundImage: ThemeSetup.getBackgroundURL('arrow_up_red.svg'),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    display: 'inline-block',
    height: '14px',
    width: '10px'
  }
};
